import { render, staticRenderFns } from "./flowManageDesign.vue?vue&type=template&id=2bfc727d&scoped=true&"
import script from "./flowManageDesign.vue?vue&type=script&lang=js&"
export * from "./flowManageDesign.vue?vue&type=script&lang=js&"
import style0 from "./flowManageDesign.vue?vue&type=style&index=0&id=2bfc727d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc727d",
  null
  
)

export default component.exports